import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Table, Checkbox  } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { getInvoiceList, doInvoiceDelete, doInvoicesPushToXero } from "../../../../redux/invoice/invoiceState";
import { handleTableChange } from "../../../../utils/index";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import CreateInvoiceOption from "./CreateInvoiceOption";
import { formatDateTimeOrNull } from "utils/index";

const InvoiceTable = ({recordList, pagination, doSearch, filters, doDelete, isLoggedInXero, executePushToXero, ...props}) => {
  	const {getColumnSearchProps} = ColumnSearchFilter();
	const [selectedIds, setSelectedIds] = useState([]);
	const rowSelection = {
		selectedRowKeys: selectedIds,
		onChange: (selectedRowKeys) => {
			setSelectedIds(selectedRowKeys);
		},
		getCheckboxProps: (record) => ({
			disabled: !isLoggedInXero || !record.for_push_to_xero,
		}),
	};

  	const columns = [
	    {
	        title: `Invoice #`,
	        dataIndex: 'inv_number',
	        key: 'inv_number',
	        width: '11%', 	        
	        ...getColumnSearchProps('inv_number'),
	        sorter: true, 
	        render:(inv_number) => <span>{inv_number}</span> 
	    },
		{
	        title: `Client`,
	        dataIndex: 'inv_client_name',
	        key: 'inv_client_name',
	        width: '22%', 	        
	        ...getColumnSearchProps('inv_client_name'),
	        sorter: true, 
	        render:(inv_client_name) => <span>{inv_client_name}</span> 
	    },
	    {
	        title: `Type`,
	        dataIndex: 'inv_type_name',
	        key: 'inv_type_name',
	        width: '15%',
	        ...getColumnSearchProps('inv_type_name'), 
	        sorter: true,
			render:(inv_type_name, record) => <div key={`type_${record.inv_id}`}>
					<div>{inv_type_name}</div>
					<div><i>{`${record.is_monthly ? record.month_year  : ''}`}</i></div>
				</div> 
	    },
		{
	        title: <div className="text-right">Amount Due</div>,
	        dataIndex: 'inv_amount_due',
	        key: 'inv_amount_due',
	        width: '12%',
	        sorter: true,
			render:(inv_amount_due) => <div className="text-right">{inv_amount_due}</div> 
	    },
		{
	        title: <div className="text-right">Created Date</div>,
	        dataIndex: 'created_at',
	        key: 'created_at',
	        width: '12%', 	        
	        sorter: true, 
	        render:(created_at) => <div className="text-right">{formatDateTimeOrNull(created_at, "YYYY-MM-DD")}</div> 
	    },
	    {
	        title: `Status`,
	        dataIndex: 'inv_status_name',
	        key: 'inv_status_name',
	        width: '12%',
	        ...getColumnSearchProps('inv_status_name'), 
	        sorter: true,
	    },
	    {
	        title: <CreateInvoiceOption/>,
	        dataIndex: 'inv_id',
	        key: 'inv_id',
	        width: '10%',
	        render:(inv_id, record) => <CrudOption 
				baseRoute="/console/invoices" 
				recordId={inv_id} 
				allowDelete={record.inv_status_id !== 10} 
				allowEdit={record.inv_type_id == 211}
				deleteHandler={doDelete}/>
	    },
    ];
	
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return ( <>
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      	
	      		<SearchFilter searchHandler={doSearch} filters={filters} pagination={pagination}/>
	      	
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.inv_id}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}  
					rowSelection={rowSelection}           	
	        	/>
	      	</div>
	    </Card>
		<div className="w-full flex gap-4 justify-end text-right my-3">
			{isLoggedInXero == 'connected' && (
				<Button
					type="button"
					extra={`crud-button ${selectedIds.length > 0 ? '' : 'disabled'}`}
					disabled={selectedIds.length < 1}
					onClick={() => executePushToXero({ids: selectedIds})}
				>
					Push to Xero
				</Button>
			)}
		</div>
	</>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.invoice.invoiceList?.items,
	pagination: state.invoice.invoiceList?.pagination,
	filters: state.invoice.invoiceList?.filters,
  	requesting: state.invoice.invoiceList?.requesting,
  	error: state.invoice.invoiceList?.error,
	isLoggedInXero: state.invoice.isLoggedInXero,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getInvoiceList(filters)),
  doDelete: (id) => dispatch(doInvoiceDelete(id)),
  executePushToXero: (data) => dispatch(doInvoicesPushToXero(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceTable);
